import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ApisService } from '@core/services/apis.service';
import { TranslateService } from '@ngx-translate/core';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-add-team-members',
  templateUrl: './add-team-members.component.html',
  styleUrls: ['./add-team-members.component.scss']
})
export class AddTeamMembersComponent implements OnInit {

      public pages  : any
  public tempData = [];
  public totalItems = 0;


formData: any = {
  image: '',
  name: '',
  job_title: ''

}; 
  InvestorsId: any;
 
  previewUrl: any;

  constructor(
    private router: Router,
    private apisService: ApisService,
    private toastr: ToastrService,
    public _translateService: TranslateService
  ) {}

    ngOnInit(): void {
     this.getTags();
     this. getInvestorsId(); 

    }
 
    // Handle PDF selection
onPdfSelected(event: any): void {
  if (event.target.files.length > 0) {
    this.formData.pdf = event.target.files[0];
  }
}

getTags() {
  this.apisService.contractsType().subscribe({
    next: (response: any) => {
      this.pages = response.data || [];
      this.totalItems = this.pages.length;
      console.log('pages:', this.pages);
    },
    error: (error: any) => {
      console.error('Error fetching contract types:', error);
    }
  });
}



onFileSelected(event: any): void {
  console.log('File selected:', event); // للتأكد من تشغيل الدالة
  
  if (event.target.files.length > 0) {
    const file = event.target.files[0];
    this.formData.image = file;
    
    // عرض معاينة الصورة الجديدة
    this.previewLogo(file);
  }
}

// دالة خاصة لعرض معاينة الصورة
previewLogo(file: File): void {
  const reader = new FileReader();
  
  reader.onload = (e: any) => {
    console.log('File preview loaded'); // للتأكد من اكتمال التحميل
    this.previewUrl = e.target.result;
  };
  
  reader.onerror = (error) => {
    console.error('Error previewing image:', error);
    this.toastr.error('Error loading image preview');
  };
  
  reader.readAsDataURL(file);
}
removeLogo(): void {
  console.log('Removing logo'); // للتأكد من تشغيل الدالة
  this.formData.image = null;
  this.previewUrl = null;
  
  // إعادة تعيين حقل الـ file input
  const fileInput = document.getElementById('logoUpload') as HTMLInputElement;
  if (fileInput) {
    fileInput.value = '';
  }
}

//   onFileSelected(event: any): void {
//   if (event.target.files.length > 0) {
//     this.formData.image = event.target.files[0];
//   }
// }
    cancel(): void {
      this.router.navigate(['/team-members']);
    }
  
    getTranslation(translations: any[], locale: string) {
      return translations.find(translation => translation.locale === locale) || {};
    }
 getInvestorsId(){ 
  this.apisService.investors().subscribe({
    next: (response: any) => {
      // The actual array is in response.data.data
      this.InvestorsId = response.data;  

     
      console.log("InvestorsId:", this.InvestorsId);
    },
    error: (error: any) => {
      console.log(error);
    }
  }
    
  )
 }

    
    /*----------  Submitting the form  ----------*/
    
    /*----------  Submitting the form  ----------*/
onSubmit() {
  const form = new FormData();
  form.append('image', this.formData.image);

 form.append('name', this.formData.name);
  form.append('job_title', this.formData.job_title);

  this.apisService.addTeamMembers(form).subscribe({
    next: (response: any) => {
      console.log('Added successfully:', response);
      this.toastr.success(this._translateService.instant('MENU.DASHBOARD.updated_successfully'));
      this.router.navigate(['/team-members']);
    },
    error: (error: any) => {
      console.error('Error adding contract:', error);

      if (error.error?.errors) {
        const errors = error.error.errors;
        // Show all validation errors from backend
        Object.keys(errors).forEach((key) => {
          this.toastr.error(errors[key][0]);
        });
      } else {
        this.toastr.error(this._translateService.instant('MENU.DASHBOARD.something_went_wrong'));
      }
    },
  });
}


}